import ACCOUNT from '../../../api/account';


const baseAccount = {
  label: '',
  account_number: '',
  swift: '',
  iban_code: 'PL',
  person: '',
  owner: null,
};

const state = {
  account: { ...baseAccount },
  accounts: [],
  popupActive: false,
};

const getters = {};

const actions = {
  indexAccounts({ commit }) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      ACCOUNT.index().then(response => {
        commit('setAccounts', response.data);
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  accountsBy({ commit }, person = undefined) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      ACCOUNT.accountsByOriginal(person).then(response => {
        commit('setAccounts', []);
        commit('setAccounts', response.data);
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  storeAccount({ commit, dispatch, state }, { person, personOriginal }) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      commit('setAccountPersonOwner', person);
      ACCOUNT.store(state.account).then(response => {
        dispatch('accountsBy', personOriginal);
        commit('storeAccount', response.data);
        commit('clearAccount');
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  updateAccount({ commit, dispatch, state }, personOriginal) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      ACCOUNT.update(state.account).then(response => {
        dispatch('accountsBy', personOriginal);
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  showAccount({ commit, dispatch }, id) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      ACCOUNT.show(id).then(response => {
        commit('setAccount', response.data);
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  destroyAccount({ commit }, id) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      ACCOUNT.destroy(id).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  clearAccount({ commit }) {
    commit('clearAccount');
  },
  clearAccounts({ commit }) {
    commit('clearAccounts');
  },
};

const mutations = {
  setName(state, label) {
    state.account.label = label;
  },
  setCompany(state, id) {
    state.account.person = id;
  },
  setNumber(state, account_number) {
    state.account.account_number = account_number;
  },
  setSwift(state, swift) {
    state.account.swift = swift;
  },
  setIban(state, iban_code) {
    state.account.iban_code = iban_code;
  },
  storeAccount(state, account) {
    state.accounts.push(account);
  },
  clearAccount(state) {
    state.account = { ...baseAccount };
  },
  clearAccounts(state) {
    state.accounts = [];
  },
  setAccount(state, account) {
    state.account = account;
  },
  setAccounts(state, accounts) {
    state.accounts = accounts;
  },
  showNewAccount(state, account) {
    state.accounts.push(state.account);
  },
  setPopup(state, type) {
    state.popupActive = type;
  },
  setDefaultAccount(state, isDefault) {
    state.account.is_default = isDefault;
  },
  setPerson(state, person) {
    state.account.person = person;
  },
  setAccountPersonOwner(state, person) {
    state.account.person = person;
    state.account.owner = JSON.parse(localStorage.getItem('person')).id;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
